import React from 'react';

import PageLayout from './PageLayout';
import PageProvider from './PageProvider';

const LoginPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout />
        </PageProvider>
    );
};

export default LoginPage;
